import { Box } from '@chakra-ui/react';

import BadgeEcomerce from 'Component/badge-ecommerce';
import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const ColumnAccount = ({ values }) => {
  return (
    <Box className={styles['column-account__container']}>
      <Box>
        <BadgeEcomerce ecommerce={values?.accountLivestreams?.ecommerce} accountName={values?.accountLivestreams?.name} />
      </Box>
      <TextRegular className={styles['column-account__text']}>
        {values?.accountType} | {values?.brand}
      </TextRegular>
    </Box>
  );
};

export default ColumnAccount;
